import type { ChannelType } from '@/types/channel.types';
import { BLAdmin } from '@/types/profile.types';
import jwtDecode from '@/utils/jwt';

const getUserFromToken = (token: string): BLAdmin & { channelType: ChannelType | 'unset' | undefined } =>
  jwtDecode(token);

export default getUserFromToken;
